import { styled } from 'solid-styled-components';
import { H1, H2 } from 'src/app/components';

export const H1Styled = styled(H1)`
    margin-bottom: 2px;
    padding: 0 64px;
`;

export const H2Styled = styled(H2)`
    margin-bottom: 20px;
    padding: 0 64px;
    min-height: 44px;
`;

export const QrCodeWrapper = styled.div`
    padding: 0 24px 24px;
`;
